import api from "@/lib/api";

// معرّف جلسة زائر ثابت على الجهاز لقياس قمع التحويل (زيارة → ضغط ابدأ → تسجيل → أول مشروع)
export const funnelSid = () => {
  let sid = localStorage.getItem("rawaj_sid");
  if (!sid) {
    sid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 64);
    localStorage.setItem("rawaj_sid", sid);
  }
  return sid;
};

export const track = (event, source = "", extra = {}) => api.post("/public/track", { event, sid: funnelSid(), source, ...extra }).catch(() => {});
